import Vue from 'vue'
import VueRouter from 'vue-router'
import TheStakeholderRequest from '@/views/stakeholderrequest/TheStakeholderRequest.vue'
import TheDisasterRecovery from '@/views/disasterrecovery/TheDisasterRecovery.vue'
import TheReviewASubmittedDeathRecord from '@/views/reviewasubmitteddeathrecord/TheReviewASubmittedDeathRecord.vue'
import TheNoRecordOfMarriage from '@/views/noRecordOfMarriage/TheNoRecordOfMarriage.vue'
import TheFamilyHistoryFeedback from '@/views/familyhistoryfeedback/TheFamilyHistoryFeedback.vue'
import TheFeeWaiver from '@/views/feeWaiver/TheFeeWaiver.vue'
import TheSessionRetrieval from '@/views/task/TheSessionRetrieval.vue'
import TheOrder from '@/views/order/TheOrder.vue'
import NotFound from '@/components/NotFound.vue'
import TheMarriageApplication from '../views/MarriageApplication.vue/TheMarriageApplication.vue'
import TheRefundRequest from "@/views/refundRequest/TheRefundRequest.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/marriageform',
    name: 'Marriage form',
    component: TheMarriageApplication
  },
  {
    path: '/order',
    name: 'Order form',
    component: TheOrder
  },
  {
    path: '/stakeholderrequest',
    name: 'Stakeholder certificate application request',
    component: TheStakeholderRequest
  },
   {
     path: '/disasterrecovery',
     name: 'Disaster recovery replacement certificate request',
     component: TheDisasterRecovery
   },
  {
    path: '/norecordofmarriage',
    name: 'No Record of Marriage Form',
    component: TheNoRecordOfMarriage
  },
  {
    path: '/feewaiver',
    name: 'Fee Waiver Form',
    component: TheFeeWaiver
  },
  {
    path: '/familyhistoryfeedback',
    name: 'Family History Feedback',
    component: TheFamilyHistoryFeedback
  },
  {
    path: '/review-a-submitted-death-record',
    name: 'Review a submitted death record',
    component: TheReviewASubmittedDeathRecord
  },
  {
    path: '/refund-request',
    name: 'Refund request',
    component: TheRefundRequest
  },
  {
    path: '/session/retrieve',
    name: 'Your applications',
    component: TheSessionRetrieval
  },
  {
    path: '/',
      redirect: { name: 'Review a submitted death record' }
  },
  {
    path: '*',
    name: 'Page not found',
    component: NotFound
  },
]

// dont use history mode otherwise you need to put forwarding rules for each path into amplify otherwise there will be access denied errors
const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router